import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Tooltip, DatePicker } from 'antd';
import * as Icons from '@ant-design/icons';
import moment from 'moment';

const SelectorAnio = props => {
  const [anio, setAnio] = useState('2020');

  useEffect(() => {
    props.onChangeAnio(anio);
  }, [anio]);

  return (
    <Row>
      <Col span={4} offset={4}>
        <>
          <span style={{ fontSize: 18, fontWeight: 'bold' }}> Año </span>
          <Tooltip
            title="Seleccione el año del reporte"
            style={{ marginLeft: 10 }}
          >
            <Icons.QuestionCircleOutlined />
          </Tooltip>
        </>
      </Col>
      <Col span={8}>
        <DatePicker
          onChange={date => setAnio(date.format('YYYY'))}
          picker="year"
          defaultValue={moment().year(anio)}
        />
      </Col>
    </Row>
  );
};

SelectorAnio.propTypes = { onChangeAnio: PropTypes.func.isRequired };

export default SelectorAnio;
